import { render, staticRenderFns } from "./tab2StudentManagement.vue?vue&type=template&id=5f2eb32a&scoped=true"
import script from "./tab2StudentManagement.vue?vue&type=script&lang=js"
export * from "./tab2StudentManagement.vue?vue&type=script&lang=js"
import style0 from "./tab2StudentManagement.vue?vue&type=style&index=0&id=5f2eb32a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2eb32a",
  null
  
)

export default component.exports